import { useFormContext } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';

import { Typography } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useSessionDeletion } from 'features/sessions/hooks';

import { Button } from 'shared/components/Button';

export const SessionsTableFormDeleteButton = () => {
  const { getValues } = useFormContext();
  const sessionId = getValues('coachingSessionId');
  const navigate = useNavigate();
  const { email } = useParams();
  const redirectToSessionsList = () => {
    navigate(`/hde/participants/${email}/sessions`, { replace: true });
  };

  const { openConfirmationModal } = useSessionDeletion(
    sessionId,
    redirectToSessionsList
  );

  return (
    <Button
      variant="ghost"
      onClick={openConfirmationModal}
      data-testid="sidebar-delete-session"
    >
      <Icon name={iconNames.bin} fill="var(--fgDanger)" />{' '}
      <Typography color="red">Delete session</Typography>
    </Button>
  );
};
